import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert, AlertTitle } from "@mui/material";

const NotificationContext = createContext({});

export const useNotificationContext = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = (props) => {
  const [enable, setEnable] = useState(true);
  const [notificationState, setNotificationState] = useState({
    isOpen: false,
    heading: "Error",
    message: "Something Went Wrong",
    variant: "error",
    size: "medium",
  });

  const disableNotification = async () => {
    await setEnable(false);
    setNotificationState({
      ...notificationState,
      isOpen: false,
    });
  };
  const enableNotification = () => {
    setEnable(true);
    setNotificationState({
      ...notificationState,
      isOpen: false,
    });
  };
  const hideNotification = () => {
    setNotificationState({
      ...notificationState,
      isOpen: false,
    });
  };
  const showNotification = (heading, message, variant, size) => {
    let selectedMessage = message;
    if (
      message?.toLowerCase()?.includes("cannot read properties of undefined") ||
      message?.toLowerCase()?.includes("undefined")
    ) {
      selectedMessage = "Something Went Wrong, Please Try Again Later.";
    }
    setNotificationState({
      ...notificationState,
      isOpen: true,
      heading: heading ?? "Error",
      message:
        selectedMessage ?? "Something Went Wrong, Please Try Again Later.",
      size: size ?? "medium",
      variant: variant ?? "error",
    });
  };

  return (
    <NotificationContext.Provider
      value={{
        showNotification,
        hideNotification,
        enableNotification,
        disableNotification,
      }}
    >
      {props.children}
      {enable && (
        <Snackbar
          open={notificationState.isOpen}
          onClose={hideNotification}
          autoHideDuration={5000}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        >
          <Alert
            onClose={hideNotification}
            severity={notificationState.variant ?? "error"}
            sx={{ width: "100%" }}
          >
            <AlertTitle>{notificationState?.heading ?? " Error"}</AlertTitle>
            {notificationState?.message ?? "Something went wrong"}
          </Alert>
        </Snackbar>
      )}
    </NotificationContext.Provider>
  );
};
